// Backoff schedule for the bounded high-res heal (useHealPendingHighRes).
// Three polls by default: a fast logo system heals in ~5s, a slow one within
// ~65s cumulative.
export const DEFAULT_HEAL_DELAYS_MS: readonly number[] = [5_000, 15_000, 45_000];

// Owner rule (Nichlas 9/9): at most 3 GetLogo per mutation. The env override
// is capped here so a longer list in the yml can never widen that budget.
export const MAX_HEAL_ATTEMPTS = 3;

/**
 * Parses REACT_APP_HEAL_DELAYS_MS ("3000,8000,15000") into a poll schedule.
 * Guards: unset/blank -> default; every entry must be a finite integer > 0,
 * otherwise the WHOLE value is rejected and the default applies (a half-valid
 * schedule would silently change the cadence); at most MAX_HEAL_ATTEMPTS
 * entries are kept (extra entries are dropped, not merged).
 */
export function parseHealDelaysMs(
  raw: string | undefined,
  fallback: readonly number[] = DEFAULT_HEAL_DELAYS_MS
): number[] {
  if (!raw || raw.trim().length === 0) return [...fallback];
  const parts = raw.split(",").map((p) => p.trim());
  const delays: number[] = [];
  for (const part of parts) {
    if (part.length === 0) return [...fallback];
    const value = Number(part);
    if (!Number.isFinite(value) || !Number.isInteger(value) || value <= 0) {
      return [...fallback];
    }
    delays.push(value);
  }
  if (delays.length === 0) return [...fallback];
  return delays.slice(0, MAX_HEAL_ATTEMPTS);
}
